import {
  convertUTCDateTimeToLocal,
  toDisplayDateTime,
} from "../../blocks/fields/formatDate";
import { calculateAge } from "../contact/calculateAge";

/** The derived field the page bar titles a contact audit with. */
export const ContactAuditTitleField = "contactaudittitle";
/** The derived age, from the audit's birthdate. */
export const ContactAuditAgeField = "contactauditage";

// The title names when the snapshot was taken, since one contact has many audits.
export function adaptContactAuditRecord(
  record: Record<string, unknown>
): Record<string, unknown> {
  const fullName = [record.g4gdpr_firstname, record.g4gdpr_lastname]
    .filter((part) => typeof part === "string" && part.length > 0)
    .join(" ");
  const createdOn = toDisplayDateTime(
    convertUTCDateTimeToLocal(
      record.createdon as string | Date | null | undefined
    )?.toDate()
  );

  const title = [fullName, "Contact Audit", createdOn]
    .filter((part) => part)
    .join(" ");

  const birthdate = record.g4gdpr_birthdate as string | Date | null | undefined;

  return {
    ...record,
    [ContactAuditTitleField]: title,
    [ContactAuditAgeField]: calculateAge(birthdate),
  };
}
